import { useEffect, useState } from "react";

import { useRouter } from "next/router";

const useRouterPush = () => {
  const router = useRouter();
  const [queryParams, setQueryParams] = useState(router.query);

  useEffect(() => setQueryParams(router.query), [router.query]);

  const updateQueryParams = (newQueryParams) => {
    let queries = { ...router.query, ...newQueryParams };
    setQueryParams(queries);
    router.push(
      {
        pathname: router.pathname,
        query: queries,
      },
      undefined,
      { scroll: false, shallow: true }
    );
  };

  return {
    queryParams,
    updateQueryParams,
    routerPush: router.push,
  };
};

export default useRouterPush;
